@if (!isBigQuantity) {
  <gl-working-table
    [class.without-menu]="isViewingSharedProject() | async"
    [class.fullWidth]="(isViewingSharedProject() | async) && !isLeftMenuOpen"
    [class.isMobile]="isMobile"
    [isMobile]="isMobile"
  ></gl-working-table>
}

<div
  class="panels"
  [class.without-menu]="isViewingSharedProject() | async"
  [class.bottomFullWidth]="(isViewingSharedProject() | async) && !isLeftMenuOpen"
  [class.isMobile]="isMobile"
  >
  <div class="elements">
    @if (!isMobile) {
      <div>
        @if (
          (isViewingSharedProject() | async) === false
          ) {
          <gl-recommendations
            >
          </gl-recommendations>
        }
        @if (notificationsService.currentNotification) {
          <gl-notifications
            (closeNotification)="closeNotification()"
            [text]="notificationsService.currentNotification.text"
            [type]="notificationsService.currentNotification.type"
            [timeToClose]="notificationsService.currentNotification.timeToClose"
            >
          </gl-notifications>
        }
      </div>
    }
  </div>

  <div>
    @if (isMobile) {
      <div class="projectInfoMobile">
        <div class="projectInfoMobileContainer">
          @if (sharedProject && sharedProject.name && (isViewingSharedProject() | async)) {
            <div
              class="projectNameMobile"
              >
              {{ sharedProject.name }}
            </div>
          }
          @if (projectName && (isViewingSharedProject() | async) === false) {
            <div
              class="projectNameMobile"
              >
              {{ projectName }}
            </div>
          }
          @if (workSpaces.length > 0) {
            <div class="cargoSpaceNameMobile">
              {{ workSpaces[currentWorkSpaceIndex].cargoSpaces[0].name | indexedName }}
            </div>
          }
        </div>
        @if (projectNote) {
          <button icon-button (click)="openNote()">
            <gl-icon [name]="'document'"></gl-icon>
          </button>
        }
      </div>
    }
    @if (isCargoSpaceDefined(0)) {
      <div class="overlaps">
        @if ((isViewingSharedProject() | async) ? (isViewingSharedProject() | async) && isBottomMenuOpen : true) {
          <gl-overlaps-loading-spaces [isMobile]="isMobile"
          ></gl-overlaps-loading-spaces>
        }
      </div>
    }
  </div>
</div>
@if ((isViewingSharedProject() | async) ? isLeftMenuOpen : true) {
  @if (!isMobile) {
    <gl-main-panel
      [class.without-menu]="isViewingSharedProject() | async"
    ></gl-main-panel>
  }
}
@if ((isViewingSharedProject() | async) === false && isMobile) {
  <gl-mobile-menu
    [workingTable]="workingTable"
    >
  </gl-mobile-menu>
}

@if (openNoteClicked) {
  <div class="projectNote" (glMousedownOutside)="openNote()">
    <button icon-button (click)="openNote()">
      <gl-icon [name]="'close'"></gl-icon>
    </button>
    <h3>
      {{ projectNote }}
    </h3>
  </div>
}
